import * as c from 'models/constants';
import * as React from 'react';
import { IStore } from 'redux/IStore';
import { Dispatch, connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { ITranslateProps, InjectedFormProps } from 'models/common';
import { InjectedManualBookingModalProps, ManualBookingScreen } from '../';
import { translate } from 'react-i18next';
import { IBlockedTimeFormData, IManualBookingFormData } from 'models/shop/manualbooking';
import { addBlockedTime, deleteOtherScheduleTime, moveBlockedTime } from 'redux/modules/shop/bookingtimetables';
import { IBookingTimeTable } from 'models/shop/bookingtimetables';
import { IRescheduleProps } from 'models/shop/schedule';
import { Button, LoadingOverlayWrapper, Modal } from 'components';
import { CustomerCheckboxField } from 'containers/Shop/ShopBundlesServicesAddEdit/ShopServicesSingleAddEdit/CustomerCheckboxField';
require('./style.scss');

interface IOwnProps {
	shopId?: string;
	officeId?: string;
	resourceId?: string;
	time?: string;
	endTime?: string;
	timezone?: string;
	timetables?: IBookingTimeTable[];
	description?: string;
	rescheduleProps?: IRescheduleProps;
}

interface IState {
	isSubmitting: boolean;
}

type IProps = IOwnProps &
	ReturnType<typeof stateToProps> &
	ReturnType<typeof dispatchToProps> &
	ITranslateProps &
	InjectedFormProps &
	InjectedManualBookingModalProps;

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UpdateRecurringSelectionScreenComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.onUpdateOnlySelectedItemChange = this.onUpdateOnlySelectedItemChange.bind(this);

		this.state = {
			isSubmitting: false,
		};
	}

	componentDidMount(): void {
		if (this.props.mode === 'add' || this.props.shopOrderCard?.isFetching) {
			this.props.setScreen(ManualBookingScreen.Main);
		} else {
			this.props.change('updateOnlySelectedItem', true);
			this.props.change('enableNotifications', false);
		}
	}

	private onUpdateOnlySelectedItemChange = (value: boolean) => {
		this.props.change('updateOnlySelectedItem', value);
	};

	public render() {
		const { t } = this.props;

		const footer: JSX.Element = (
			<div className="update-recurring-selection-screen__footer">
				<Button
					onClick={() => {
						// reset prop
						this.props.change('updateOnlySelectedItem', '');
						this.props.setScreen(ManualBookingScreen.Main);
					}}
					className="update-recurring-selection-screen__button left"
				>
					{t('BSPortal_Common_Cancel')}
				</Button>

				<Button
					onClick={() => {
						this.setState({ isSubmitting: true });
						this.props
							.submitEditManualBooking()
							.then((res: { status: 'ok' | 'error'; message: string }) => {
								console.info('Res: ', res);
								if (res?.status === 'ok') {
									// TODO: show success message
									this.props.closeModal();
								}
							})
							.catch((err) => {
								this.props.setScreen(ManualBookingScreen.Main);
								console.error('Err: ', err);
							});
					}}
					className="update-recurring-selection-screen__button right"
					disabled={this.state.isSubmitting}
				>
					{t('ManualBookingModal_UpdateRecurringSelection_Update')}
				</Button>
			</div>
		);

		return (
			<Modal size="small" modalClass="modal-with-form update-recurring-selection-screen" footer={footer}>
				<LoadingOverlayWrapper active={this.state?.isSubmitting} spinner={true}>
					<div className="row">
						<div className="col-12">
							<h2 className="update-recurring-selection-screen__title">
								{t('ManualBookingModal_UpdateRecurringSelection_Title')}
							</h2>
							<p className="update-recurring-selection-screen__text">
								{t('ManualBookingModal_UpdateRecurringSelection_Text')}
							</p>
							<div className="update-recurring-selection-screen__inputContainer">
								<label className="update-recurring-selection-screen__inputButton">
									<input
										key={'currentOnly'}
										name={'currentOnly'}
										value={'currentOnly'}
										type="radio"
										checked={this.props.currentFormValues?.updateOnlySelectedItem === true}
										onChange={() => this.onUpdateOnlySelectedItemChange(true)}
									/>
									<span className="update-recurring-selection-screen__inputText">
										{t('ManualBookingModal_UpdateRecurringSelection_CurrentAppointmentOnly')}
									</span>
								</label>
								<label className="update-recurring-selection-screen__inputButton">
									<input
										key={'allUpcoming'}
										name={'allUpcoming'}
										value={'allUpcoming'}
										type="radio"
										checked={this.props.currentFormValues?.updateOnlySelectedItem === false}
										onChange={() => this.onUpdateOnlySelectedItemChange(false)}
									/>
									<span className="update-recurring-selection-screen__inputText">
										{t('ManualBookingModal_UpdateRecurringSelection_AllUpcomingAppointments')}
									</span>
								</label>
							</div>
						</div>
						<div className="col-12">
							<p className="update-recurring-selection-screen__text notificationToggleText">
								{t('ManualBookingModal_UpdateRecurringSelection_ToggleText')}
							</p>
							<Field
								name={`enableNotifications`}
								component={CustomerCheckboxField}
								type="checkbox"
								label={t('ManualBookingModal_UpdateRecurringSelection_ToggleLabelText')}
								dontShowCustomer={true}
							/>
						</div>
					</div>
				</LoadingOverlayWrapper>
			</Modal>
		);
	}
}

const stateToProps = (state: IStore, ownProps: IOwnProps) => {
	let currentFormValues: IManualBookingFormData = null;
	const currentOffice = state?.manageShop?.shop?.offices.find((off) => off.id === ownProps.officeId) || null;

	if (state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN] && state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN].values) {
		currentFormValues = state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN].values;
	}

	return {
		currentFormValues,
		manageShop: state.manageShop,
		currentOffice,
		shopOrderCard: state.shopOrderCard,
	};
};

const dispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => ({
	addBlockedTime: (form: IBlockedTimeFormData, officeId: string, timezone: string) =>
		dispatch(addBlockedTime(form, officeId, timezone)),
	moveBlockedTime: (form, timezone) => dispatch(moveBlockedTime(ownProps.timetables, form, timezone)),
	deleteBlockedTime: () => dispatch(deleteOtherScheduleTime(ownProps.timetables)),
});

export const UpdateRecurringSelectionScreen = connect(
	stateToProps,
	dispatchToProps,
)(
	reduxForm({
		form: c.FORM_NAME_MANUAL_BOOKING_PLAN,
		enableReinitialize: false,
		destroyOnUnmount: false,
	})(UpdateRecurringSelectionScreenComponent),
);
